/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchCriteria } from './SearchCriteria';
import {
    SearchCriteriaFromJSON,
    SearchCriteriaFromJSONTyped,
    SearchCriteriaToJSON,
    SearchCriteriaToJSONTyped,
} from './SearchCriteria';

/**
 * 
 * @export
 * @interface SearchQueryRequest
 */
export interface SearchQueryRequest {
    /**
     * 
     * @type {Array<SearchCriteria>}
     * @memberof SearchQueryRequest
     */
    criteria?: Array<SearchCriteria>;
}

/**
 * Check if a given object implements the SearchQueryRequest interface.
 */
export function instanceOfSearchQueryRequest(value: object): value is SearchQueryRequest {
    return true;
}

export function SearchQueryRequestFromJSON(json: any): SearchQueryRequest {
    return SearchQueryRequestFromJSONTyped(json, false);
}

export function SearchQueryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchQueryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'criteria': json['criteria'] == null ? undefined : ((json['criteria'] as Array<any>).map(SearchCriteriaFromJSON)),
    };
}

export function SearchQueryRequestToJSON(json: any): SearchQueryRequest {
    return SearchQueryRequestToJSONTyped(json, false);
}

export function SearchQueryRequestToJSONTyped(value?: SearchQueryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'criteria': value['criteria'] == null ? undefined : ((value['criteria'] as Array<any>).map(SearchCriteriaToJSON)),
    };
}

